module.exports = __webpack_public_path__ + "static/media/adhesivo_zocalos_acetico.f385331d.jpg";